import getBasePath from '@/common/functions/api-resource';

const basePath = getBasePath('recebimento', 'nota-debito/configuracao');

const notaDebitoActions = {
  buscarCamposFiltro: { methods: 'GET', url: `${basePath}/campos/filtro` },
};

export default (resource) => resource(`${basePath}`, {}, notaDebitoActions);
